import React from "react";
import PropTypes from "prop-types";
import styles from "./AccountHeader.module.css";
import { ChevronDown } from "react-ikonate";
import Button from "components/Button";
import { capitalizeName } from "components/shared/capitalizeName";
import { AddCoIboModal } from "../AddCoIboModal/AddCoIboModal";
import { useTranslation } from "react-i18next";

export function AccountHeader({
  onClick,
  activeUser,
  iboNum,
  currentPage,
  contactCount,
  onAddIBOClick,
}) {
  const showChevron = contactCount > 1;
  const toTitleCase = (text) => {
    return text.replace(
      /\w\S*/g,
      (word) => word.charAt(0).toUpperCase() + word.substr(1).toLowerCase()
    );
  };
  const {t} = useTranslation();

  return (
    <div className={styles.container}>
      <div className={styles.headerLabels}>
        <span>{t("Logged in as")}</span>
        {currentPage === "homepage" && (
          <span className={styles.iboHeader}>{t("IBO Number")}</span>
        )}
      </div>
      <div className={styles.values}>
        <div className={contactCount > 1 ? styles.clickableUser : styles.nonClickableUser} onClick={onClick}>
          <span className={styles.activeUser}>{toTitleCase(activeUser)}</span>
          {showChevron && <ChevronDown className={styles.dropdownArrow} />}
        </div>

        {currentPage === "homepage" ? (
          <span className={styles.iboNum}>{iboNum}</span>
        ) : (
          contactCount < 2 && (
            <div className={styles.addCoContainer}>
              <div>
                <Button
                  buttonText={t("Add Co-IBO")}
                  onClick={onAddIBOClick}
                  className={styles.btnHollow}
                />
              </div>
            </div>
          )
        )}
      </div>
    </div>
  );
}

AccountHeader.propTypes = {
  onClick: PropTypes.func,
  activeUser: PropTypes.string,
  iboNum: PropTypes.string,
  currentPage: PropTypes.string.isRequired,
  contactCount: PropTypes.number.isRequired,
  onAddIBOClick: PropTypes.func, // Add this if it's missing in the PropTypes
};
